<template>
  <div>
    <el-button type="primary" size="small" icon="el-icon-back" style="margin-bottom: 10px" @click="$router.back(-1)">返回</el-button>
    <!-- 表格 -->
    <el-table :data="newTableData" v-loading="loading" border stripe style="width: 100%" :header-cell-style="{'background':'#f5f7fa'}">
      <el-table-column align="center" prop="i" label="序号" width="50"> </el-table-column>
      <el-table-column align="center" prop="templateName" label="模版名称"> </el-table-column>
      <el-table-column align="center" prop="templateStatus_name" label="模版状态"> </el-table-column>
      <el-table-column align="center" prop="notaryStatus_name" label="公证开通状态"> </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column align="center" prop="updateTime" label="更新时间"> </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" width="180">
        <template slot-scope="scope">
          <el-button @click="openDetails(scope.row.id)" size="small">查看</el-button>
          <!-- <el-button @click="deleteTem(scope.row.templateId)" type="danger" size="small">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <TemDetails ref="temDetails" @updateList="getList($route.query.busiTemplateId)"/>
  </div>
</template>

<script>
import TemDetails from './details';
import { conVertDate } from "@/utils/tools";
export default {
  components: {
    TemDetails
  },
  data() {
    return {
      loading: false,
      tableData: [],
      notaryStatus: null
    }
  },
  created() {
    let busiTemplateId = this.$route.query.busiTemplateId;
    this.notaryStatus = this.$route.query.notaryStatus;
    console.log(this.$route.query)
    this.getList(busiTemplateId);
  },
  mounted() {
    
  },
  computed: {
    newTableData() {
      let temData = this.tableData;
      temData.map((item, index) => {
        item.i = index + 1;
        item.templateStatus_name = item.templateStatus == 1? '有效' : '无效';
        item.createTime = conVertDate(item.createTime, false);
        item.updateTime = conVertDate(item.updateTime, false);
        switch (item.notaryStatus) {
          case 0:
            item.notaryStatus_name = '未开通';
            break;
          case 1:
            item.notaryStatus_name = '电子签审核中';
            break;
          case 2:
            item.notaryStatus_name = '公证处审核中';
            break;
          case 3:
            item.notaryStatus_name = '审核通过';
            break;
        
          default:
            break;
        }
      });
      return temData;
    }
  },
  methods: {
    getList(busiTemplateId) {
      this.loading = true;
      this.$api.getAnnexTemplateList({
        templateId: busiTemplateId,
        pageNumber: 1,
        pageSize: 100
      }).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data;
        }
      }).finally(() => {
        this.loading = false;       
      });
    },
    // 打开模版详情
    openDetails(templateId) {
      this.$refs.temDetails.open(templateId, 'fujianTem', 2);
      // this.$router.push({
      //   path: '/templateExamine/addTem',
      //   query: {
      //     type: 'docTem',
      //     templateId: templateId
      //   }
      // });
    },
    // 添加模板
    onAdd() {
      // this.$refs.temDetails.open(0, 'add');
      this.$router.push({
        path: '/templateExamine/addTem',
        query: {
          type: 'add',
          busiTemplateId: this.$route.query.busiTemplateId
        }
      });
    },
    // 删除模板
    deleteTem(templateId) {
      this.$confirm('删除该模板, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.delNotaryDocTemplate(templateId).then(res => {
          this.$successCallback(res, '删除成功' ,() => {
            this.getList(this.$route.query.busiTemplateId);
          })
        })
      }).catch(() => {
        // 选择取消,不做操作 
      });
      
    }
  }
}
</script>
<style scoped>

</style>